import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { unregisterServiceWorkersAndClearCaches } from 'utils/serviceWorkerCleanup';
import { RefreshDataWrapper } from './styled';

function RefreshData() {
	const { t } = useTranslation();
	const [showRefreshModal, setShowRefreshModal] = useState(
		localStorage.getItem('wrongApiVersion') === 'true',
	);

	const handleRefresh = async () => {
		localStorage.removeItem('apiVersion');
		localStorage.removeItem('wrongApiVersion');

		try {
			await unregisterServiceWorkersAndClearCaches();
		} catch (e) {
			console.warn('RefreshData cleanup failed', e);
		}

		window.location.reload();
	};

	useEffect(() => {
		const checkLocalStorage = () => {
			setShowRefreshModal(localStorage.getItem('wrongApiVersion') === 'true');
		};

		const interval = setInterval(checkLocalStorage, 10000);

		return () => clearInterval(interval);
	}, []);

	return showRefreshModal ? (
		<RefreshDataWrapper>
			<span>{t('shared.refresh.message')}</span>
			<Button onClick={handleRefresh} variant="text">
				{t('shared.refresh.button').toUpperCase()}
			</Button>
		</RefreshDataWrapper>
	) : null;
}

export default RefreshData;
